import React from 'react';
import CatalogItemStore from '../../_flux/stores/catalog_items_store';
import FittingStationStore from '../../_flux/stores/fitting_station_store';
import MapStore from '../../_flux/stores/map_store';
import PostcodeStore from '../../_flux/stores/postcode_store';
import { getCatalogFilterStoreByProductType } from '../../_flux/stores/catalog_filter_store/factory';
import CatalogProducts from '../../_flux/components/product_revamp/catalog_products';
import * as ProductTileGoogleAnalytics from '../../_modules/google_analytics/product/product_tiles';
import * as NoResultSuggestionsGoogleAnalytics from '../../_modules/google_analytics/catalog/no_result_suggestions';
import * as SortingGoogleAnalytics from '../../_modules/google_analytics/catalog/sorting';
import { noop, pickBy } from '../../../lib/utilities';
import { CatalogSortingStore } from '../../_flux/stores/catalog_sorting_store';
import { setSkuAction, setTypeAction, showAction } from '../../_flux/actions/notify_me_actions';
import { NotificationTypes } from '../../_flux/constants/notify_me/notification_types';
import { updateFiltersAction } from '../../_flux/actions/catalog_filter_actions';
import { createSuggestions } from '../../_modules/suggestions/suggestions';
import { getDefaultValueForFilter } from '../../_flux/helper/filters/get_default_value_for_filter';
import { setSortingAction } from '../../_flux/actions/catalog_sorting_actions';
import { sortingToOptionValue } from '../../_modules/sorting/sorting_to_option_value';
import { sortingOptionsToSelectOptions } from '../../_modules/sorting/sorting_options_to_select_options';
import { handleView } from '../handle_view';
import { applyFilters } from '../../_flux/helper/apply_filters';
import { show } from '../../_flux/actions/friendbuy_light_box_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import LightboxActions, { openAction as openCarFittingStationFinder } from '../../_flux/actions/lightbox_actions';
import StationsActions from '../../_flux/actions/fitting_station_actions';
import { setAction as setProductAction } from '../../_flux/actions/products_actions';
import { setQuantityAction as setFittingStationQuantityAction } from '../../_flux/actions/fitting_station_actions';
import MapActions from '../../_flux/actions/map_actions';
import { ProductsStore } from '../../_flux/stores/products_store';
import FittingStationFinderConstants from '../../_flux/constants/fitting_station_finder_constants';
import { getMap } from '../../_flux/helper/gmap';
import parseGoogleLatLng from '../../_flux/helper/parse_google_lat_lng';
import { loadStations } from '../../_modules/fitting_station/load_stations';
import { FsfPages } from '../../_constants/fsf_pages';
import openAlternativeProductStockOnClick from './open_alternative_product_stock_onlick';
import { loadGoogleMapDependencies } from '../../_global/initGoogleMapDependencies';
import ActiveStationsActions from '../../_flux/actions/active_station_actions';

const stores = {
    catalogSortingState: CatalogSortingStore,
    catalogItemState: CatalogItemStore,
};

const render = ({ catalogFiltersState, catalogSortingState, catalogItemState }, options) => {
    const { products, buyerAssistUrl } = catalogItemState;
    let activeFilters = pickBy(catalogFiltersState, (filterValue, filterName) => filterValue !== getDefaultValueForFilter(filterName));
    activeFilters = unsetVehicleSuggestion(activeFilters);
    const suggestions = createSuggestions(activeFilters, options.currencyIsoCode);
    const currentSorting = sortingToOptionValue(catalogSortingState.currentSorting);
    const sortingOptions = sortingOptionsToSelectOptions(catalogSortingState.sortingOptions);

    return (
        <CatalogProducts
            products={products}
            suggestion={suggestions}
            sorting={currentSorting}
            sortingOptions={sortingOptions}
            staticUrl={options.staticUrl}
            metroArea={options.metroArea}
            showShowDetailsButton={options.showShowDetailsButton}
            onAddPostcodeClick={noop}
            onNotifyMeClick={onNotifyMeClick}
            onOpenFSFClick={onOpenFSFClick}
            onClickAddToCart={onClickAddToCart}
            onImproveClick={options.onImproveClick}
            onRemoveClick={options.onRemoveClick}
            onSortingChange={options.onSortingChange}
            onProductClick={onProductClick}
            currencyIsoCode={TYROOLA.globals.currencyIsoCode}
            onSeeHowItWorksClick={e => e.preventDefault() ^ show()}
            productType={options.productType}
            onAlternativeProductStockClick={onAlternativeProductStockClick}
            buyerAssistUrl={buyerAssistUrl}
        />
    );
};

export const init = (container, options) => {
    stores.catalogFiltersState = getCatalogFilterStoreByProductType(options.productType);

    return handleView(
        stores,
        render,
        getOptions(options),
        container
    );
};

const getOptions = options => ({
    ...options,
    onSortingChange: onSortingChange(options.productType),
    onImproveClick: onImproveClick(options.productType),
    onRemoveClick: onRemoveClick(options.productType),
});

const onAlternativeProductStockClick = (productSku, productBatchStocks) => {
    const { products } = CatalogItemStore.getState();
    let product = products.find(product => product.sku === productSku);
    openAlternativeProductStockOnClick(product, productBatchStocks);
};

const onClickAddToCart = product => {
    addProductToCart(product);
}

async function addProductToCart(props) {
    await _prepareCartRequest(props);
    window.location = `${location.origin}${TYROOLA.globals.baseUrl}/cart/`;
}

function _prepareCartRequest(props) {
    const wheelAlignmentTwo = props.wheelAlignmentTwo ? 1 : 0;
    const wheelAlignmentFour = props.wheelAlignmentFour ? 1 : 0;
    let qty = 0;
    if (props.stock > 0) {
        if (props.stock < 4) {
            qty = props.stock;
        } else if (props.stock >= 4) {
            qty = 4;
        }
    }

    return ActiveStationsActions.addProductToCartAction(
        { id: '', qty },
        props.sku,
        false,
        true,
        wheelAlignmentTwo,
        wheelAlignmentFour,
    );
}

const onOpenFSFClick = productSku => {
    loadGoogleMapDependencies();
    TYROOLA.mapsInitiated.then(() => {
        LightboxActions.totalPagesChangeAction(FsfPages.WITH_SUCCESS_NOTIFICATION);
        const { products } = CatalogItemStore.getState();
        let product = products.find(product => product.sku === productSku);
        product.id = productSku;
        if (product.stock > 0) {
            if (product.stock < 4) {
                product.qty = product.stock;
            } else if (product.stock >= 4) {
                product.qty = 4;
            }
        }

        let qty = FittingStationStore.getState().quantity;
        if (null !== qty) {
            product.qty = qty;
        }

        const { appliedPostcode } = PostcodeStore.getState();
        const latLng = parseGoogleLatLng(MapStore.getState().latLng);
        if (typeof latLng.lat !== 'undefined'
            && typeof latLng.lng !== 'undefined'
            && null !== appliedPostcode) {
            let stations = FittingStationStore.getState().stations;
            if (stations.length > 0) {
                let currentProducts = ProductsStore.getState();
                if (currentProducts.length > 0 && productSku !== currentProducts[0].id) {
                    StationsActions.clearStationAction();
                    setProductAction([product]);
                    loadStations(appliedPostcode);
                }
            } else {
                setProductAction([product]);
                loadStations(appliedPostcode);
            }
            LightboxActions.openAction();
            LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);
        } else {
            setProductAction([product]);
        }

        openCarFittingStationFinder();
    });
};

const onNotifyMeClick = productSku => {
    const { products } = CatalogItemStore.getState();
    const product = products.find(product => product.sku === productSku);
    setSkuAction(productSku);
    setTypeAction(product.stock > 0 ? NotificationTypes.LOW_ON_STOCK : NotificationTypes.OUT_OF_STOCK);
    showAction();
    ProductTileGoogleAnalytics.openNotifyWhenRestockedLightbox(productSku);
};

const onProductClick = clickedProductSku => {
    const { products } = CatalogItemStore.getState();
    ProductTileGoogleAnalytics.clickOnProduct(
        'Catalog Item',
        products.findIndex(product => product.sku === clickedProductSku)
    );
};

const onSortingChange = productType => optionValue => {
    const [sorting, direction] = optionValue.split('::');
    setSortingAction(sorting, direction);
    applyFilters(productType);
    SortingGoogleAnalytics.changeSorting(sorting, direction);
};

const onImproveClick = productType => (filter, value) => {
    updateFiltersAction({ [filter]: value });
    applyFilters(productType);
    NoResultSuggestionsGoogleAnalytics.improveFilter(filter, value);
};

const onRemoveClick = productType => filter => {
    updateFiltersAction({ [filter]: getDefaultValueForFilter(filter) });
    applyFilters(productType);
    NoResultSuggestionsGoogleAnalytics.removeFilter(filter);
};

function unsetVehicleSuggestion(activeFilters) {
    if (Filters.VEHICLE_TYRES in activeFilters) {
        delete activeFilters[Filters.VEHICLE_TYRES];
    }

    if (Filters.VEHICLE_MAKE in activeFilters) {
        delete activeFilters[Filters.VEHICLE_MAKE];
    }

    if (Filters.VEHICLE_ENGINE in activeFilters) {
        delete activeFilters[Filters.VEHICLE_ENGINE];
    }

    if (Filters.VEHICLE_SERIES_CHASSIS in activeFilters) {
        delete activeFilters[Filters.VEHICLE_SERIES_CHASSIS];
    }

    if (Filters.VEHICLE_DETAILS in activeFilters) {
        delete activeFilters[Filters.VEHICLE_DETAILS];
    }

    if (Filters.VEHICLE_SERIES in activeFilters) {
        delete activeFilters[Filters.VEHICLE_SERIES];
    }

    if (Filters.VEHICLE_CHASSIS in activeFilters) {
        delete activeFilters[Filters.VEHICLE_CHASSIS];
    }

    if (Filters.REGISTRATION in activeFilters) {
        delete activeFilters[Filters.REGISTRATION];
    }

    if (Filters.VEHICLE_STATE in activeFilters) {
        delete activeFilters[Filters.VEHICLE_STATE];
    }

    return activeFilters;
}
